module.exports = __webpack_public_path__ + "assets/img/37_1431_big.be5c3579.jpg";